import React from "react";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import DOMPurify from "isomorphic-dompurify";
import { styled } from "@acko-tech/building-blocks.ui.common";
import { useContext } from "react";
import { Context } from "@components/useContext/context";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import Hyperlink from "@components/common/hyperlink";
import Badge from "@components/common/badge";

const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  color: #36354c;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  border-radius: 12px;
  border: 1px solid #efe9fb;
  width: 100%;

  span {
    font-weight: 500;
  }
`;

const Heading = styled.div`
  font-size: ${(props) => (props.isDesktop ? "16px" : "14px")};
  span {
    font-weight: 500
  }
`;

const Description = styled.div`
  margin-top: 12px;
  font-size: ${(props) => (props.isDesktop ? "14px" : "12px")};
  line-height: ${(props) => (props.isDesktop ? "20px" : "18px")};
  ${(props: { wrapperStyles: any }) => props.wrapperStyles}
`;

const HeadingParagraph = ({ children, ...props }) => {
  const { wrapperStyles, question, price, strikeThroughPrice, edit, para, styles, actions ,is_visible, badge, containerStyles } = props || {};
  const { isDesktop } = useContext(Context);
  const { on_click } = actions || {};

  return is_visible? (
    <Container style={styles}>
      {badge?.text && 
          <div style={{ display: "flex", justifyContent: "center", width: "100%", marginBottom: "1rem" }}>
            <Badge
              is_visible
              text={badge?.text}
              type={badge?.type}
              image={badge?.image?.imgSrc}
              styles={{ ...badge?.styles }}
              textStyles={badge?.textStyles}
            />
          </div>
      }
      <Flex
        justifyContent="space-between"
        alignItems="center"
        style={{ width: "100%" }}
      >
        <Heading
          isDesktop={isDesktop}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(question) }}
        />
        {edit ? (
        <Hyperlink
          clickHandler={() => {
            if (on_click?.length > 0) {
              on_click?.forEach((eachFunc: any) => {
                typeof eachFunc.funCall === "function" &&
                  eachFunc.funCall(eachFunc.args);
              });
            }
          }}
          is_visible={true}
          text={edit}
          styles={{
            display: "inline-block",
            width: "max-content",
            color: "#1B73E8"
          }}
        />
        ):( price && (
        <span
          style={{
            fontSize: "14px",
            fontWeight: "600"
          }}
        >
          ₹{price}
        </span>
        ))
      }
      </Flex>

      {para && (
        <Flex flexDirection="row" alignItems="flex-start" style={containerStyles}>
          <Description
            isDesktop={isDesktop}
            wrapperStyles={wrapperStyles}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(para) }}
          />
          {strikeThroughPrice && 
          <span
          style={{
            textDecoration: "line-through",
            fontSize: "14px",
            marginLeft: "8px",
            color: "#A6A6A6",
            alignSelf: "center"
          }}
        >
          ₹{strikeThroughPrice}
        </span>
        }
        </Flex>
      )}
    </Container>
  ) : null;
};

export default HeadingParagraph;
